import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from "../PA.Core.IF.BO";
import {ESRecord} from "../lib/ESRecord";
import {eRecordChangeType, ESRecordChanges, IRecordChange} from "../lib/ESRecordChanges";

export function DefaultChanges(BO: IBusinessObject,
                               BOMainRecord: ESRecord,
                               options?: IBusinessObjectChangesOptions)
    : IBusinessObjectChanges
{
    //--
    let returnValue: IBusinessObjectChanges = {
        bHasChanges: false,
        bMainRecordExists: BOMainRecord._rowExists,
        Changes: []
    }

    let opts = options || {}

    let changes = ESRecordChanges.findChanges(BOMainRecord, options)

    if(_.isEmpty(changes))
        return returnValue

    returnValue.bHasChanges = true
    returnValue.Changes = _.map(changes, (aChange) => {

        let msg: string
        let rowid = `${aChange.mapperUI || aChange.mapper} (${aChange.lk || aChange.id})`

        switch (aChange.type){
            case eRecordChangeType.New:
                msg = `New record ${rowid}`
                break;

            case eRecordChangeType.Delete:
                msg = `Deleted record ${rowid}`
                break;

            case eRecordChangeType.Update:
                msg = `Updated record ${rowid}, has changes: ${_.map(aChange.changes, (fldInfo) => {
                    return `${fldInfo.column} is now "${fldInfo.value}" was "${fldInfo.previous}"`
                }).join(", ")}`
                break;

        }

        return {
            Message: msg || "Unknown Type",
            RecordChange: aChange
        }
    })

    return returnValue
}